import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../../material.module';

@Component({
  selector: 'additional-customers-filter-table',
  templateUrl: './customer-filter-table.component.html',
  styleUrls: ['./customer-filter-table.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, MaterialModule]
})
export class CustomerFilterTableComponent {
  @Input() public searchTerm = '';
  @Input() public placeHolderText = 'Search By Customer Name';
  @Input() public dataTestId = 'customer-name-search-input';
  @Input() public customerNames: any[] = [];
  @Input() public columns: any[] = [];
  @Input() public numberOfPages = 0;
  @Input() public removeButtonText = 'Remove Selected';

  @Output() public searchTermChange = new EventEmitter<string>();
  @Output() public searchTable = new EventEmitter<string>();
  @Output() public clearSearch = new EventEmitter<void>();
  @Output() public allSelected = new EventEmitter<any>();
  @Output() public selection = new EventEmitter<any>();
  @Output() public removeSelected = new EventEmitter<void>();

}

